// @ts-nocheck
/* eslint-disable */
import SceneGeometryMulti from "./multi";

export default class SceneGeometryTraffic extends SceneGeometryMulti {
	/**
	 * Vytvoreni multi geometrie - napr. data z lookupu.
	 *
	 * @param  {Object} data Vstupni data
	 */
	constructor(scene, itemId, data) {
		super(scene, itemId, data);

		this._degree = null;
		this._markerData = null;
		this._disableClick = true;

		this._setData();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneGeometryTraffic",
			type: "geometry"
		};
	}

	/**
	 * Ziskani options z dat.
	 *
	 * @return {Object}
	 */
	_optionsFromData() {
		let options = {};

		let colors = ["#43ca00","#43ca00","#fab90c","#fa7200","#e51601"];
		let outlineColors = ["#cdfac1","#cdfac1","#fce7ae","#ffe0c6","#ffa3a3"];

		let degree = this._data.extend.traffic.load;
		options.color = colors[degree-1];
		options.outlineColor = outlineColors[degree-1];

		options.outlineWidth = 2;
		options.opacity = 1;
		options.outlineOpacity = 1;

		options.title = "";

		return options;
	}

	/**
	 * Nastaveni dat.
	 */
	_setData() {
		let traf = this._data.extend.traffic;

		this._degree = traf.load;

		if (this._marker) { return; }

		let names = ["actSpeed", "load", "maxSpeed", "delay"]
		let marker = {};

		for(let i = 0; i < names.length; i++) {
			let name = names[i]

			if(name in traf) {
				marker[name] = traf[name];
			}
		}
		marker.title = this._data.title;
		marker.loadColor = this._options.color;

		this._markerData = marker;
	}
}
